import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import SvgIcon from '@mui/material/SvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LensActiveIcon = function LensActiveIcon(props) {
  return /*#__PURE__*/_jsxs(SvgIcon, _objectSpread(_objectSpread({
    viewBox: "0 0 500 500"
  }, props), {}, {
    "data-element": "SvgIcon",
    "data-component": "LensActiveIcon",
    "data-source-file": "lens-active.tsx",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "white",
      d: "M481.2 249.8h-22.8c-.4 0-.7.2-1 .2-5.1-46.9-44.4-83.5-92.7-83.5-36.1 0-67.2 20.7-82.8 50.7-9.7-5.7-20.4-9-31.8-9-11.3 0-22.1 3.3-31.8 9-15.6-30-46.6-50.7-82.8-50.7-48.2 0-87.5 36.5-92.7 83.3H20.9c-5.8 0-10.4 4.7-10.4 10.4 0 5.8 4.7 10.4 10.4 10.4h21.9c5.2 46.8 44.5 83.3 92.7 83.3 51.8 0 93.8-42 93.8-93.8 0-7.8-1.2-15.2-3-22.4 7.3-4.1 15.4-6.5 23.8-6.5s16.5 2.4 23.8 6.5c-1.8 7.2-3 14.7-3 22.4 0 51.8 42 93.8 93.8 93.8 48.3 0 87.6-36.6 92.7-83.5.4 0 .7.2 1 .2h22.8c5.8 0 10.4-4.7 10.4-10.4 0-5.8-4.6-10.4-10.4-10.4z",
      "data-element": "path",
      "data-component": "LensActiveIcon",
      "data-source-file": "lens-active.tsx"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "135.5",
      cy: "260.2",
      r: "72.9",
      "data-element": "circle",
      "data-source-file": "lens-active.tsx"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "364.7",
      cy: "260.2",
      r: "72.9",
      "data-element": "circle",
      "data-source-file": "lens-active.tsx"
    }), /*#__PURE__*/_jsx("path", {
      stroke: "white",
      strokeWidth: 15.625,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: "10",
      d: "M187.6 249.8c0-23-18.7-41.7-41.7-41.7M416.8 249.8c0-23-18.7-41.7-41.7-41.7",
      "data-element": "path",
      "data-source-file": "lens-active.tsx"
    })]
  }));
};